import styled from 'styled-components';

const Container = styled.div`
  flex-grow: 1;
`;

export default Container;
